import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUnitsListContentRequest, getUnitsListContentRequestError, getUnitsListContentRequestSuccess } from "../../slices/Content/GetUnitsListContentSlice";

export const GetUnitsListContentApi = (limit, page) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
    }).toString();

    const urlWithParams = `${endpoints.getUnitsListContent}?${queryParams}`;
    try {
        dispatch(getUnitsListContentRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUnitsListContentRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUnitsListContentRequestError(_error));
            });
    } catch (error) { }
};
